interface StepperProps {
  step?: number;
  steps?: number;
}

export const Stepper = ({ step = 1, steps = 2 }: StepperProps) => {
  return (
    <div
      className="h-2 transition-width duration-300 ease-out bg-primary"
      style={{ width: `${(step / steps) * 100}%` }}
    />
  );
};
